export const ANALYTICS_VIEW = {
  TOTAL: 'Total',
  SOURCE: 'Source',
  POINT: 'Point',
};
